import { DateTime, DurationUnit } from 'luxon';

interface Props {
  start: number;
  step: DurationUnit;
  stepCount: number;
  stepSize: number;
}

const getOverTimeTicks = ({ start, step, stepCount, stepSize }: Props): number[] => {
  const startDateTime = DateTime.fromMillis(start);

  return Array.from({ length: stepCount }).map((_, i) => {
    return startDateTime.plus({ [step]: i * stepSize }).toMillis();
  });
};

export default getOverTimeTicks;
